import { useParams, useSearchParams } from "react-router-dom";
import ApprovalDetailFlow, { type ApprovalFlowStep } from "@/features/approvals/approval-detail";
import ApprovalMissing from "@/features/approvals/approval-missing";
import { DataSourceBadge } from "@/components/data-display/data-source-badge";
import { useApprovalDetail } from "@/hooks/use-approval-detail";

const STEPS: ApprovalFlowStep[] = ["idle", "confirm", "mfa", "approved"];

function resolveStep(raw: string | undefined): ApprovalFlowStep {
  const value = raw === "approved" ? "approved" : raw;
  return STEPS.find((s) => s === value) ?? "idle";
}

export default function ApprovalDetailPage() {
  const { id } = useParams();
  const [searchParams] = useSearchParams();
  const step = searchParams.get("step") ?? undefined;
  const result = searchParams.get("result") ?? undefined;
  const { detail, status, loading, error, source, refresh } = useApprovalDetail(id!);

  if (loading) {
    return (
      <div className="flex items-center justify-center py-16">
        <div className="spinner" aria-label="Loading approval" />
      </div>
    );
  }

  if (error || !detail) return <ApprovalMissing id={id!} />;

  return (
    <div>
      <div className="mb-3 flex items-center gap-2">
        <DataSourceBadge source={source} />
        <button
          type="button"
          onClick={refresh}
          className="text-xs text-muted underline hover:text-ink"
        >
          Refresh
        </button>
      </div>
      <ApprovalDetailFlow detail={detail} initialStep={resolveStep(step ?? result)} status={status} />
    </div>
  );
}
